// extracted by mini-css-extract-plugin
export default {"wrapper":"ActivityTypeIcon__wrapper___KhEzt","icon":"ActivityTypeIcon__icon___Bxq8g"};